/**
 * Created by dushyantha on 9/19/16.
 */
'use strict';

(function () {
    angular
        .module('crewProfile')
        .component('crewProfileComponent', {
            templateUrl: 'profile/components/crew-profile-component.html',
            controller: function (CommonMasterData, crewProfileDTOFactory, CrewingSelectionHelper, ProfileService,
                                  AuthService, $scope, $http, EventManagerService, MessageService, $timeout, PopupManager) {
                var vm = this;
                vm.tab = 1;
                vm.calenderData=[];
                vm.editableCrewBatches = [];
                vm.batchSelectReady = false;
                vm.model = {
                    countryList: {}
                };
                vm.carrier = {};
                vm.hubs = [];
                vm.employmentTypes = [
                    {value: 'Temporary', label: 'Temporary'},
                    {value: 'Permanent', label: 'Permanent'}
                ];
                vm.autoImportAllowedClients = {};
                vm.gender = [
                    {code: 'M', description: 'Male'},
                    {code: 'F', description: 'Female'}
                ];
                vm.model = {
                    isDisablePersonalInfo: true,
                    isDisableCrewInfo: true,
                    isDisabledEmpInfo: true,
                    isWebAccessInfo: true,
                    isEditKingContact: true,
                    isDisabledPrimaryContact: true,
                    isEditTrainerType: true,
                    isEditSingleSignOn: true,
                    crewGroups: [],
                    offContracts: [],
                    showcontact: false,
                    languageDetails: [],
                    selectedLanguage: '',
                    isDisabledLangInfo: true,
                    selectedFleet: '',
                    isDisablePaymentEdit: true,
                    exclusiveCrew: '',
                    airportExclusion: '',
                    airportInclusion: '',
                    currentSelection: '',
                    newPopover: {
                        popOverFlag: false
                    },
                    newAirportExPopover: {
                        popOverFlag: false
                    },
                    lastOpenPopOver: {popOverFlag: false},
                  lastAirportExOpenPopOver: {popOverFlag: false},
                  lastDateRangeOpenPopOver:{popOverFlag: false},
                    isDefValidationEditable: false,
                    isImportPrivExist : false,
                  isDisableExclusionSave : true,
                  isDisableInclusionSave : true,
                  isEditACMIData : false,
                  isAcmiDatesValid : true,
                  singleSignOn:{
                    isSSOEnabled: false
                  },
                  acmiTypes : [],
                  isDisableACMIInfo : false
                };
                vm.nationalityDesc = '';
                vm.trainingStageRows = [];
                vm.selectedTrainingStageRow = null;
                vm.enableTrainingStageSequence = false;
                vm.airportRecencyData=[];

              vm.getNationality=function(input){
                  if(!input){
                    return vm.nationalityList;
                  }
                   return vm.nationalityList.filter(function (nationality) {
                    return nationality['description'].substr(0, input.length).toLowerCase() == input.toLowerCase();
                  });

                }


                //set upgrade date picker max date to any future date
                var MAX_TIMESTAMP = 8640000000000000;
                vm.upgradeDateOption = { maxDate : new Date(MAX_TIMESTAMP)};
                // Allow past dates for exclusion/inclusion date edits (audit trail captures who changes them)
                vm.exclusionDateOption = {};

                vm.fleetExperiencePopOver = {};

                vm.civilStatus = [
                    {code: 'UNMARRIED', name: 'UNMARRIED'},
                    {code: 'MARRIED', name: 'MARRIED'},
                    {code: 'DIVORCED', name: 'DIVORCED'}
                ];


                vm.component = {categoryLabel:'childElements', uniqueField: 'valueFieldName'};

                //Need to get the value from API,once the specific Application parameter is added
                vm.allowPassportValidation = true;
                // getPassportParam();
                getHubs();
                vm.selectedBase={};

                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CLICK_CREATE_PROFILE, createNewCrewProfile);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CREW_PROFILE.EDIT_FAIL, stateChange);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CREW_PROFILE.PAYMENT_EDIT_STATE_CHANGE, paymentEditStateChange);
                EventManagerService.registerEventListener("set.position.dateRange",adaptManagementPosition);

                function paymentEditStateChange(){
                	vm.model.isDisablePaymentEdit = !vm.model.isDisablePaymentEdit;
                }

                function stateChange() {
                    vm.model[vm.currentSelection] = false;
                }

                vm.tabClick = function (tabID) {
                    vm.tab = tabID;
                    setMinDate();
                    setDefaultUpgradeData();
                    loadOtherHubHours();
                    if (tabID === 7 && !vm.airportRecencyLastRefreshTime) {
                        vm.refreshAirportRecencyData();
                    }
                };

                function loadOtherHubHours(){
                	EventManagerService
					.notifyEventListeners(
							EventManagerService.EVENT.TOOLBAR.OTHER_HUB_HOURS.SEARCH);
                }

                // function getPassportParam() {
                //   CommonMasterData.getPassportParamValue(
                //     function (response) {
                //       if (response.appParamValueDTO.paramValue === 'N') {
                //         vm.allowPassportValidation = true;
                //       }
                //     },
                //     function () {
                //       console.log('Passport Param value retrival error');
                //
                //     }
                //   );
                // }
              // function getPassportParam() {
              //   RemoteService.getPassportParamValue().then(
              //     function (response) {
              //       self.model.allowPassportValidation = response.appParamValueDTO.paramValue;
              //       successFn(self.model.passportParamValue);
              //     },
              //     function (error) {
              //       errorFn(error.msg);
              //     }
              //   );
              //
              // }


              function adaptManagementPosition(mgtPos){
                if(!vm.crewDetailsDTO == null){
                  angular.forEach(mgtPos, function(value) {
                    angular.forEach(vm.crewDetailsDTO.crewPositionListForView, function(pos) {

                      vm.crewDetailsDTO.crewPositionListForView
                    });

                  });
                }

                EventManagerService.notifyEventListeners("adapt.position.dateRange", mgtPos);
              }

                function loadCrewList() {
                    CommonMasterData.getCountryList(
                        function (response) {
                            vm.model.countryList = response;
                        },
                        function () {
                            console.log('Country list retrieval error');
                        }
                    );
                }

                function loadImportPriviledge(){
                	CommonMasterData.getImportPriviledges(
                            function (response) {
                                vm.model.isImportPrivExist = response;
                            },
                            function () {
                                console.log('Import Priviledge retrieval error');
                            }
                        );
                }
                loadImportPriviledge();

                function getHubs() {
                  ProfileService.getHubs(
                    function (response) {
                        vm.hubs = response;

                        if (vm.crewDetailsDTO.employerHub) {
                          vm.employmentInfoDTO.employerHub = _.find(vm.hubs, {hubCode: vm.crewDetailsDTO.employerHub});
                        }
                    },
                    function (error) {
                        console.log('Hub list retrieval error');
                    }
                  );
                }

                function adaptPersonalInfo() {
                    vm.personalInfoDTO = crewProfileDTOFactory.PersonalInfoDTO();
                    vm.personalInfoDTO.firstName = vm.crewDetailsDTO.firstName;
                    vm.personalInfoDTO.middleName = vm.crewDetailsDTO.middleName;
                    vm.personalInfoDTO.lastName = vm.crewDetailsDTO.lastName;
                    vm.personalInfoDTO.lastNameWithInitials = vm.crewDetailsDTO.lastNameWithInitials;
                    vm.personalInfoDTO.callName = vm.crewDetailsDTO.callName;
                    vm.personalInfoDTO.religion = vm.crewDetailsDTO.religion;
                    if (vm.crewDetailsDTO.civilStatus) {
                        vm.personalInfoDTO.civilStatus = _.find(vm.civilStatus, {name: vm.crewDetailsDTO.civilStatus});
                    }
                    if (vm.crewDetailsDTO.gender) {
                        vm.personalInfoDTO.gender = _.find(vm.gender, {code: vm.crewDetailsDTO.gender});
                    }
                    vm.personalInfoDTO.dob = vm.crewDetailsDTO.dob;
                    vm.personalInfoDTO.status = vm.crewDetailsDTO.status;
                    vm.personalInfoDTO.trainee = vm.crewDetailsDTO.trainee;
                    vm.personalInfoDTO.traineeStartDate = vm.crewDetailsDTO.traineeStartDate;
                  vm.personalInfoDTO.traineeEndDate = vm.crewDetailsDTO.traineeEndDate;
                    vm.personalInfoDTO.seniorPilot = vm.crewDetailsDTO.seniorPilot;
                    vm.personalInfoDTO.blueLine = vm.crewDetailsDTO.blueLine;
                  vm.personalInfoDTO.probation = vm.crewDetailsDTO.probation;
                    vm.personalInfoDTO.otherHub = vm.crewDetailsDTO.otherHub;
                    vm.personalInfoDTO.coverPilotRequired = vm.crewDetailsDTO.coverPilotRequired;
                    vm.personalInfoDTO.lvp = vm.crewDetailsDTO.lvp;
                    vm.personalInfoDTO.trn = vm.crewDetailsDTO.trn;
                    vm.personalInfoDTO.etop = vm.crewDetailsDTO.etop;
                    vm.personalInfoDTO.rhs = vm.crewDetailsDTO.rhs;
                    vm.personalInfoDTO.flying = vm.crewDetailsDTO.flying;
                    if (vm.crewDetailsDTO.crewOperType) {
                        vm.personalInfoDTO.crewOperType = _.find(vm.crewOperTypes, {operTypeDesc: vm.crewDetailsDTO.crewOperType});
                    }
                    vm.personalInfoDTO.wetLeaseCrew = vm.crewDetailsDTO.wetLeaseCrew;
                    vm.personalInfoDTO.acmiStartDate = vm.crewDetailsDTO.acmiStartDate;
                }

                function adaptCrewInfo() {
                    vm.crewInfoDTO = crewProfileDTOFactory.CrewInfoDTO();
                    vm.crewInfoDTO.crewId = vm.crewDetailsDTO.crewId;
                    if (vm.crewDetailsDTO.crewTypeCode) {
                        vm.crewInfoDTO.crewTypeCode = _.find(vm.crewTypes, {crewTypeCode: vm.crewDetailsDTO.crewTypeCode});
                    }
                    if (vm.crewDetailsDTO.group) {
                        vm.crewInfoDTO.group = _.find(vm.crewGroups, {groupCode: vm.crewDetailsDTO.group});
                    }
                    if (vm.crewDetailsDTO.batchCode) {
                        vm.crewInfoDTO.batchCode = _.find(vm.crewBatchList, {crewBatchCode: vm.crewDetailsDTO.batchCode});
                    }
                    if(vm.crewDetailsDTO.alvGroupCode) {
                        vm.crewInfoDTO.alvGroup = _.find(vm.alvGroups, {alvGroupCode: vm.crewDetailsDTO.alvGroupCode});
                    }
                    vm.crewInfoDTO.boxNumber = vm.crewDetailsDTO.boxNumber;
                    vm.crewInfoDTO.uId = vm.crewDetailsDTO.uId;
                    vm.crewInfoDTO.newStaffId = vm.crewDetailsDTO.newStaffId;
                    vm.crewInfoDTO.ucid = vm.crewDetailsDTO.ucid;
                }

                function adaptEmploymentInfo() {
                    vm.employmentInfoDTO = crewProfileDTOFactory.EmploymentInfoDTO();
                    vm.employmentInfoDTO.alvCount = vm.crewDetailsDTO.alvCount
                    vm.employmentInfoDTO.dateOfContract = vm.crewDetailsDTO.dateOfContract;
                    vm.employmentInfoDTO.flexiDateOfContract = vm.crewDetailsDTO.flexiDateOfContract;
                    vm.employmentInfoDTO.dateOfJoin = vm.crewDetailsDTO.dateOfJoin;
                    if (vm.crewDetailsDTO.crewBase) {
                        vm.employmentInfoDTO.crewBase = _.find(vm.baseType, {airPortCode: vm.crewDetailsDTO.crewBase});
                    }
                    if (vm.crewDetailsDTO.employerHub) {
                      vm.employmentInfoDTO.employerHub = _.find(vm.hubs, {hubCode: vm.crewDetailsDTO.employerHub});
                    }
                    if (vm.crewDetailsDTO.contractCode) {
                        vm.employmentInfoDTO.contractInfo = _.find(vm.offContracts, {contractCode: vm.crewDetailsDTO.contractCode});
                    }
                    vm.employmentInfoDTO.passportDateOfIssue = vm.crewDetailsDTO.passportDateOfIssue;
                    vm.employmentInfoDTO.passportNumber = vm.crewDetailsDTO.passportNumber;
                    vm.employmentInfoDTO.passportDateOfExpiry = vm.crewDetailsDTO.passportDateOfExpiry;
                    if (vm.crewDetailsDTO.nationalityCode) {
                        vm.employmentInfoDTO.nationalityCode = _.find(vm.nationalityList, {code: (vm.crewDetailsDTO.nationalityCode).toString()});
                        vm.searchCriteria.nationality=vm.employmentInfoDTO.nationalityCode.description;
                        vm.allowNationalityValidation = true;
                        vm.nationalityCodeValid = true;
                    }
                    if (vm.crewDetailsDTO.crewPosition) {
                        vm.employmentInfoDTO.crewPosition = _.find(vm.mgtPositions, {crewPositionCode: vm.crewDetailsDTO.crewPosition});
                    }

                    vm.employmentInfoDTO.designation = _.find(vm.designationList, {designationId: vm.crewDetailsDTO.designationId}) || crewProfileDTOFactory.EmploymentInfoDTO().designation;

                    vm.employmentInfoDTO.crewPositionList = [];

                  vm.employmentInfoDTO.crewPositionList1 = vm.crewDetailsDTO.crewPositionListForView;

                    vm.employmentInfoDTO.lastWorkingDay = vm.crewDetailsDTO.lastWorkingDay;
                    if(!!vm.crewDetailsDTO.civilId){
                    	vm.employmentInfoDTO.civilId = vm.crewDetailsDTO.civilId;
                    }
                }

                function adaptWebAccessInfo() {
                    vm.webAccessInfoDTO = crewProfileDTOFactory.WebAccessDTO();
                    vm.webAccessInfoDTO.loginId = vm.crewDetailsDTO.loginId;
                    vm.model.singleSignOn.isSSOEnabled = vm.crewDetailsDTO.isSingleSignOnEnabled === 'Y';
                    if (vm.crewDetailsDTO.passwordCharCount) { // set dummy password
                      vm.webAccessInfoDTO.password = vm.webAccessInfoDTO.password + '@1A';
                      vm.webAccessInfoDTO.confirmPassword = vm.webAccessInfoDTO.confirmPassword + '@1A';
                        for (var i = 0; i < (vm.crewDetailsDTO.passwordCharCount - 3); i++) {
                            vm.webAccessInfoDTO.password = vm.webAccessInfoDTO.password + 'a';
                            vm.webAccessInfoDTO.confirmPassword = vm.webAccessInfoDTO.confirmPassword + 'a';
                        }
                    }
                    // set roles selected comparing the assigned roles
                    vm.webAccessInfoDTO.initiallyLoadedPassword = vm.webAccessInfoDTO.password;
                    for (var i = 0; i < vm.userRoles.length; i++) {
                      for (var j = 0; j < vm.crewDetailsDTO.assignedRoleIds.length; j++) {

                            if (vm.userRoles[i].roleId === vm.crewDetailsDTO.assignedRoleIds[j]) {
                                vm.webAccessInfoDTO.roles.push(vm.userRoles[i]);
                            }
                      }
                    }
                }

                function adaptPrimaryContact() {
                    vm.primaryContactInfo = crewProfileDTOFactory.PrimaryContactDTO();
                    vm.primaryContactInfo.residenceAddLine1 = vm.crewDetailsDTO.residenceAddLine1;
                    vm.primaryContactInfo.residenceAddLine2 = vm.crewDetailsDTO.residenceAddLine2;
                    vm.primaryContactInfo.residencePostalCode = vm.crewDetailsDTO.residencePostalCode;
                    vm.primaryContactInfo.stateProvience = vm.crewDetailsDTO.stateProvience;
                    vm.primaryContactInfo.primaryResidenceNo = vm.crewDetailsDTO.primaryResidenceNo;
                    vm.primaryContactInfo.primaryBusinessNo = vm.crewDetailsDTO.primaryBusinessNo;
                    vm.primaryContactInfo.primaryMobileNo = vm.crewDetailsDTO.primaryMobileNo;
                    vm.primaryContactInfo.primaryEmail = vm.crewDetailsDTO.primaryEmail;
                    vm.primaryContactInfo.swapContact = vm.crewDetailsDTO.swapContact;
                }

                function adaptSecondaryContact() {
                    vm.secondaryContactInfo = crewProfileDTOFactory.SecondaryContactDTO();
                    vm.secondaryContactInfo.secondaryResidenceNo = vm.crewDetailsDTO.secondaryResidenceNo;
                    vm.secondaryContactInfo.secondaryBusinessNo = vm.crewDetailsDTO.secondaryBusinessNo;
                    vm.secondaryContactInfo.secondaryMobileNo = vm.crewDetailsDTO.secondaryMobileNo;
                    vm.secondaryContactInfo.secondaryEmail = vm.crewDetailsDTO.secondaryEmail;
                }

                function adaptKinContact() {
                    vm.kinContactInfo = crewProfileDTOFactory.KinContactDTO();
                    vm.kinContactInfo.kinName = vm.crewDetailsDTO.kinName;
                    vm.kinContactInfo.kinRelationship = vm.crewDetailsDTO.kinRelationship;
                    vm.kinContactInfo.kinAddLine1 = vm.crewDetailsDTO.kinAddLine1;
                    vm.kinContactInfo.kinMobileNo = vm.crewDetailsDTO.kinMobileNo;
                }

                function adaptTrainerDetails() {
                    vm.traineeTypeInfo = crewProfileDTOFactory.TraineeTypeInfoDTO();
                    vm.traineeTypeInfo.trainerTypeCodeList = vm.crewDetailsDTO.trainerTypeCodeList;
                    vm.traineeTypeInfo.dateOfTrainerStart = vm.crewDetailsDTO.dateOfTrainerStart;

                    angular.forEach(vm.trainerTypes, function (type) {
                        type.isActive = false;
                        if(!!vm.traineeTypeInfo.trainerTypeCodeList){
                        	for (var i = 0; i < vm.traineeTypeInfo.trainerTypeCodeList.length; i++) {
                                if (vm.crewDetailsDTO.trainerTypeCodeList[i].trainerTypeCode === type.trainerTypeCode) {
                                    type.isActive = true;
                                    type.dateOfTrainerStart = vm.crewDetailsDTO.trainerTypeCodeList[i].dateOfTrainerStart;
                                    type.dateOfTrainerEnd = vm.crewDetailsDTO.trainerTypeCodeList[i].dateOfTrainerEnd;
                                }
                            }
                        }

                    });
                }

                function adaptLanguageSkillData() {
                    angular.forEach(vm.languageSkill, function (value, key) {
                        var temp = {};
                        temp.languageCode = key;
                        temp.languageDesc = value;
                        var index = findIndex(temp);
                        if (index > -1) {
                            vm.languageList.splice(index, 1);
                        }

                    });
                }

                function findIndex(data) {
                    for (var i = 0; i < vm.languageList.length; i++) {
                        if (vm.languageList[i].languageCode === data.languageCode) {
                            return i;
                        }
                    }
                    return -1;
                }

                function setNationality(){
                    var found =   _.find(vm.nationalityList,{code : vm.crewDetails.nationalityCode && vm.crewDetails.nationalityCode.toString()});
                    vm.nationalityDesc =  (!!found ) ? found.abb : '';
                };

                function adaptCrewData() {
                    vm.model.isDisablePersonalInfo = true;
                    vm.model.isDisableCrewInfo = true;
                    vm.model.isDisabledEmpInfo = true;
                    vm.model.isWebAccessInfo = true;
                    vm.model.isEditKingContact = true;
                    vm.model.isDisabledPrimaryContact = true;
                    vm.model.isEditTrainerType = true;
                    vm.model.isEditSingleSignOn = true;
                    vm.model.showcontact = true;
                    vm.isWebAccessInfo = false;
                    vm.crewDetailsDTO = angular.copy(vm.crewDetails);   // take a copy of original response
                    adaptPersonalInfo();
                    adaptCrewInfo();
                    adaptEmploymentInfo();
                    adaptWebAccessInfo();
                    adaptPrimaryContact();
                    adaptSecondaryContact();
                    adaptKinContact();
                    adaptTrainerDetails();
                    setNationality();
                    if (vm.crewDetails.crewPosition) {
                        vm.model.mgtPositionDetails = _.find(vm.mgtPositions, {crewPositionCode: vm.crewDetails.crewPosition});
                    }
                    setMinDate();
                }

                vm.saveCrewPersonalDetails = function () {
                	vm.personalInfo.$submitted = false;

                  if(vm.personalInfoDTO.wetLeaseCrew === true && (vm.personalInfoDTO.acmiStartDate === '' || vm.personalInfoDTO.acmiStartDate === null)) {
                    MessageService.warning(MessageService.MESSAGES.CREW_PROFILE.ERROR_ACMI_START_DATE_NOT_SELECTED);
                    return;
                  }

                    if (vm.personalInfo.$valid && !vm.createNewProfile && !vm.dobAfterToday) {
                      vm.model.isDisablePersonalInfo = true;
                      vm.currentSelection = 'isDisablePersonalInfo';
                      vm.crewDetails.firstName = vm.personalInfoDTO.firstName;
                      vm.crewDetails.middleName = vm.personalInfoDTO.middleName;
                      vm.crewDetails.lastName = vm.personalInfoDTO.lastName;
                      vm.crewDetails.dob = vm.personalInfoDTO.dob;
                      vm.crewDetails.lastNameWithInitials = vm.personalInfoDTO.lastNameWithInitials;
                      vm.crewDetails.callName = vm.personalInfoDTO.callName;
                      vm.crewDetails.religion = vm.personalInfoDTO.religion;
                      vm.crewDetails.gender = vm.personalInfoDTO.gender && vm.personalInfoDTO.gender.code;
                      vm.crewDetails.civilStatus = vm.personalInfoDTO.civilStatus && vm.personalInfoDTO.civilStatus.code;
                      vm.crewDetails.status = vm.personalInfoDTO.status;
                      vm.crewDetails.trainee = vm.personalInfoDTO.trainee;
                      vm.crewDetails.traineeStartDate = vm.personalInfoDTO.traineeStartDate;
                      vm.crewDetails.traineeEndDate = vm.personalInfoDTO.traineeEndDate;
                      vm.crewDetails.seniorPilot = vm.personalInfoDTO.seniorPilot;
                      vm.crewDetails.blueLine = vm.personalInfoDTO.blueLine;
                      vm.crewDetails.probation = vm.personalInfoDTO.probation;
                      vm.crewDetails.wetLeaseCrew = vm.personalInfoDTO.wetLeaseCrew;
                      vm.crewDetails.acmiStartDate = vm.personalInfoDTO.acmiStartDate;
                      vm.crewDetails.otherHub = vm.personalInfoDTO.otherHub;
                      vm.crewDetails.coverPilotRequired = vm.personalInfoDTO.coverPilotRequired;
                      vm.crewDetails.lvp = vm.personalInfoDTO.lvp;
                      vm.crewDetails.trn = vm.personalInfoDTO.trn;
                      vm.crewDetails.etop = vm.personalInfoDTO.etop;
                      vm.crewDetails.rhs = vm.personalInfoDTO.rhs;
                      vm.crewDetails.flying = vm.personalInfoDTO.flying;
                      vm.crewDetails.crewOperType = vm.personalInfoDTO.crewOperType && vm.personalInfoDTO.crewOperType.operTypeCode;
                      vm.crewDetails.blockFlag = 'personal';
                        vm.editSaveProfile();
                    }
                };

                vm.saveCrewDetails = function () {
                    vm.crewInfo.$submitted = false;
                    vm.model.isDisableCrewInfo = true;
                    vm.currentSelection = 'isDisableCrewInfo';

                    if (vm.crewInfo.$valid && !vm.createNewProfile) {
                      vm.crewDetails.crewId = vm.crewInfoDTO.crewId;
                      vm.crewDetails.crewTypeCode = vm.crewInfoDTO.crewTypeCode ? vm.crewInfoDTO.crewTypeCode.crewTypeCode : null;
                      vm.crewDetails.group = vm.crewInfoDTO.group ? vm.crewInfoDTO.group.groupCode : null;
                      vm.crewDetails.batchCode = vm.crewInfoDTO.batchCode ? vm.crewInfoDTO.batchCode.crewBatchCode : null;
                      vm.crewDetails.boxNumber = vm.crewInfoDTO.boxNumber;
                      vm.crewDetails.uId = vm.crewInfoDTO.uId;
                      vm.crewDetails.newStaffId = vm.crewInfoDTO.newStaffId;
                      vm.crewDetails.ucid = vm.crewInfoDTO.ucid;
                      vm.crewDetails.blockFlag = 'crewDetail';
                      vm.crewDetails.alvGroupCode = vm.crewInfoDTO.alvGroup ? vm.crewInfoDTO.alvGroup.alvGroupCode : null;
                        vm.editSaveProfile();
                    }

                    // Save crew attribute assignment changes (diff local edits vs original)
                    saveCrewBatchChanges();
                };

                /**
                 * Compute diff between editableCrewBatches and original assignedCrewBatches,
                 * then fire the parent callback to persist changes.
                 */
                function saveCrewBatchChanges() {
                    var originalCodes = _.map(vm.assignedCrewBatches || [], 'crewBatchCode');
                    var currentCodes = _.map(vm.editableCrewBatches || [], 'crewBatchCode');

                    var batchesToAdd = _.difference(currentCodes, originalCodes);
                    var batchesToRemove = _.difference(originalCodes, currentCodes);

                    if (batchesToAdd.length > 0 || batchesToRemove.length > 0) {
                        vm.onSaveCrewBatchChanges({batchesToAdd: batchesToAdd, batchesToRemove: batchesToRemove});
                    }
                }

                /**
                 * Handle batch selection change from multi-select component.
                 * Changes are tracked locally only — API calls happen on Save.
                 */
                vm.onCrewBatchSelectionChange = function ($event, identifier, operation, selectedItems) {
                    // The multi-select component updates editableCrewBatches directly
                    // via two-way binding. No API calls here.
                };

                vm.saveEmploymentDetails = function () {
                    vm.employmentInfo.$submitted = false;
                    if (vm.employmentInfo.$valid && !vm.createNewProfile &&  !vm.passportIssuedDateAfterToday) {
                        vm.model.isDisabledEmpInfo = true;
                        vm.currentSelection = 'isDisabledEmpInfo';
                        vm.crewDetails.dateOfContract = vm.employmentInfoDTO.dateOfContract;
                        vm.crewDetails.flexiDateOfContract = vm.employmentInfoDTO.flexiDateOfContract;
                        vm.crewDetails.dateOfJoin = vm.employmentInfoDTO.dateOfJoin;
                        vm.crewDetails.crewBase = vm.employmentInfoDTO.crewBase.airPortCode;
                        vm.crewDetails.passportDateOfIssue = vm.employmentInfoDTO.passportDateOfIssue;
                        vm.crewDetails.passportNumber = vm.employmentInfoDTO.passportNumber;
                        vm.crewDetails.passportDateOfExpiry = vm.employmentInfoDTO.passportDateOfExpiry;
                        vm.crewDetails.nationalityCode = vm.employmentInfoDTO.nationalityCode.code;
                        vm.crewDetails.crewPosition = vm.employmentInfoDTO.crewPosition.crewPositionCode;
                        vm.crewDetails.crewPositionList = vm.employmentInfoDTO.crewPositionList;
                        vm.crewDetails.lastWorkingDay = vm.employmentInfoDTO.lastWorkingDay;
                        vm.crewDetails.civilId = vm.employmentInfoDTO.civilId;
                        vm.crewDetails.alvCount = vm.employmentInfoDTO.alvCount;
                        vm.crewDetails.blockFlag = 'employment';
                        vm.crewDetails.employerHub = vm.employmentInfoDTO.employerHub.hubCode;
                        vm.crewDetails.contractCode = vm.employmentInfoDTO.contractInfo.contractCode;
                        vm.crewDetails.designationId = vm.employmentInfoDTO.designation ? vm.employmentInfoDTO.designation.designationId : null;
                        vm.editSaveProfile();
                        setMinDate();
                    }
                };

                vm.savePrimaryContactDetails = function () {
                    vm.primaryContact.$submitted = false;
                    vm.model.isDisabledPrimaryContact = true;
                    vm.currentSelection = 'isDisabledPrimaryContact';
                    if (vm.primaryContact.$valid && !vm.createNewProfile) {
                      vm.crewDetails.residenceAddLine1 = vm.primaryContactInfo.residenceAddLine1;
                      vm.crewDetails.residenceAddLine2 = vm.primaryContactInfo.residenceAddLine2;
                      vm.crewDetails.residencePostalCode = vm.primaryContactInfo.residencePostalCode;
                      vm.crewDetails.stateProvience = vm.primaryContactInfo.stateProvience;
                      vm.crewDetails.primaryResidenceNo = vm.primaryContactInfo.primaryResidenceNo;
                      vm.crewDetails.primaryBusinessNo = vm.primaryContactInfo.primaryBusinessNo;
                      vm.crewDetails.primaryMobileNo = vm.primaryContactInfo.primaryMobileNo;
                      vm.crewDetails.primaryEmail = vm.primaryContactInfo.primaryEmail;
                      vm.crewDetails.swapContact = vm.primaryContactInfo.swapContact;
                      vm.crewDetails.blockFlag = 'primaryContact';
                      vm.editSaveProfile();
                    }
                };

                vm.saveSecondaryContact = function () {
                    vm.secondaryContact.$submitted = true;
                    vm.model.showcontact = false;
                    vm.currentSelection = 'secondaryContact';
                    if (vm.secondaryContact.$valid && isSecondaryContactAvailable() && !vm.createNewProfile) {
                        vm.crewDetails.secondaryResidenceNo = vm.secondaryContactInfo.secondaryResidenceNo;
                        vm.crewDetails.secondaryBusinessNo = vm.secondaryContactInfo.secondaryBusinessNo;
                        vm.crewDetails.secondaryMobileNo = vm.secondaryContactInfo.secondaryMobileNo;
                        vm.crewDetails.secondaryEmail = vm.secondaryContactInfo.secondaryEmail;
                        vm.crewDetails.blockFlag = 'secondaryContact';
                        vm.editSaveProfile();
                    }

                };

                function isSecondaryContactAvailable(){
                	if(vm.secondaryContactInfo.secondaryResidenceNo!=null && vm.secondaryContactInfo.secondaryResidenceNo!=''){
                		return true;
                	}else if(vm.secondaryContactInfo.secondaryBusinessNo!=null && vm.secondaryContactInfo.secondaryBusinessNo!=''){
                		return true;
                	}else if(vm.secondaryContactInfo.secondaryMobileNo!=null && vm.secondaryContactInfo.secondaryMobileNo!=''){
                		return true;
                	}else if(vm.secondaryContactInfo.secondaryEmail!=null && vm.secondaryContactInfo.secondaryEmail!=''){
                		return true;
                	}else{
                		return false
                	}
                }

                vm.saveKinContactDetails = function () {
                    vm.kinContact.$submitted = true;
                    vm.currentSelection = 'kinContact';

                    if (vm.kinContact.$valid && !vm.createNewProfile) {
                        vm.model.isEditKingContact = false;
                        vm.crewDetails.kinName = vm.kinContactInfo.kinName;
                        vm.crewDetails.kinRelationship = vm.kinContactInfo.kinRelationship;
                        vm.crewDetails.kinMobileNo = vm.kinContactInfo.kinMobileNo;
                        vm.crewDetails.kinAddLine1 = vm.kinContactInfo.kinAddLine1;
                        vm.crewDetails.blockFlag = 'kinContact';
                        vm.editSaveProfile();
                    }
                };
                vm.saveChangePassword = function () {
                    vm.model.isWebAccessInfo = true;
                    vm.webAccessInfo.$submitted = false;
                    vm.currentSelection = 'isWebAccessInfo';
                    if (vm.webAccessInfo.$valid) {
                        if (vm.webAccessInfoDTO.password === vm.webAccessInfoDTO.confirmPassword) {
                            vm.model.passwordMissMatch = false;
                            vm.crewDetails.passwordInfo = AuthService.getCrewProfileChangePasswordRequest(vm.webAccessInfoDTO.loginId, vm.webAccessInfoDTO.password);
                            vm.crewDetails.blockFlag = 'webAccess';
                            vm.crewDetails.changedLoginId = vm.webAccessInfoDTO.loginId;
                            vm.crewDetails.passwordChanged = vm.webAccessInfoDTO.initiallyLoadedPassword !== vm.webAccessInfoDTO.password;
                            var roleIds = [];
                            for (var i = 0; i < vm.webAccessInfoDTO.roles.length; i++) {
                                roleIds.push(vm.webAccessInfoDTO.roles[i].roleId);
                            }
                            vm.crewDetails.assignedRoleIds = roleIds;
                            vm.editSaveProfile();
                        }
                        else {
                            vm.model.passwordMissMatch = true;
                        }
                    }
                };

              vm.changePassword = function () {
                vm.model.passwordMissMatch = false;
                vm.passwordRegexMisMatch = false;
                vm.model.isWebAccessInfo = true;
                vm.webAccessInfo.$submitted = false;
                vm.currentSelection = 'isWebAccessInfo';
                if (vm.webAccessInfo.$valid) {
                  if (vm.webAccessInfoDTO.password === vm.webAccessInfoDTO.confirmPassword) {
                    vm.model.passwordMissMatch = false;
                  }
                  else {
                    vm.model.passwordMissMatch = true;
                  }
                }
              };
              vm.changeNationality=function () {
                if (typeof vm.searchCriteria.nationality == "undefined" || vm.searchCriteria.nationality === " "){
                  vm.searchCriteria.nationality = (_.find(vm.nationalityList, {abb : (vm.nationalityDesc).toString()})).description;
                }
                if (typeof vm.searchCriteria.nationality == "undefined" || vm.searchCriteria.nationality === " "){
                  vm.nationalityCodeValid = false;
                  vm.searchCriteria.nationality="";
                  vm.nationalityValidationMessage="Nationality cannot be empty."
                }else{
                  vm.updatedNationalityCode = _.find(vm.nationalityList, {description : (vm.searchCriteria.nationality).toString()});
                  if (typeof vm.updatedNationalityCode == "undefined"){
                    vm.nationalityCodeValid = false;
                    vm.nationalityValidationMessage="Invalid Nationality."
                  }else{
                    vm.employmentInfoDTO.nationalityCode = _.find(vm.nationalityList, {description : (vm.searchCriteria.nationality).toString()});
                    vm.nationalityCodeValid = true;
                  }
                }


              }
                vm.changeConfPwd = function(){
                  if (vm.webAccessInfoDTO.password == vm.webAccessInfoDTO.confirmPassword) {
                    vm.model.passwordMissMatch = false;
                  }
                  else{
                    vm.model.passwordMissMatch = true;
                  }
                }

              vm.refreshPasswordChange = function(){
                vm.model.passwordMissMatch = false;
              }
                vm.saveTraineeDetails = function () {
                    vm.traineeInfo.$submitted = true;
                    vm.currentSelection = 'isEditTrainerType';
                    if (vm.traineeInfo.$valid) {
                        vm.model.isEditTrainerType = true;
                        vm.traineeTypeInfo.trainerTypeCodeList = [];
                        angular.forEach(vm.trainerTypes, function (type) {
                            if (type.isActive) {
                                vm.traineeTypeInfo.trainerTypeCodeList.push(type);
                            }

                        });
                      vm.crewDetails.trainerTypeCodeList = vm.traineeTypeInfo.trainerTypeCodeList;
                      vm.crewDetails.dateOfTrainerStart = vm.traineeTypeInfo.dateOfTrainerStart;
                        vm.crewDetails.blockFlag = 'traineeDetail';
                        vm.editSaveProfile();
                    }

                };

              vm.saveSingleSignOnDetails = function () {
                vm.model.ssoEmailError = false;
                if(vm.model.singleSignOn.isSSOEnabled&&!vm.primaryContactInfo.primaryEmail){
                  vm.model.ssoEmailError = true;
                  return;
                }
                vm.currentSelection = 'isEditSingleSignOn';
                vm.model.isEditSingleSignOn = true;
                vm.crewDetails.blockFlag = 'webAccess';
                if(vm.model.singleSignOn.isSSOEnabled){
                  vm.crewDetails.isSingleSignOnEnabled = 'Y';
                }else{
                  vm.crewDetails.isSingleSignOnEnabled = 'N';
                }
                vm.editSaveProfile();
              };




                vm.saveLanguageSkill = function () {
                	vm.model.isDisabledLangInfo = true;
                	vm.crewDetails.blockFlag = 'languageSkill';
                    vm.addDeleteLanguageSkill()
                };

                vm.savePaymentDetails = function () {
                    if (vm.paymentInfo.$valid) {
                        vm.updatePaymentInfo();
                    }
                };
                vm.addLanguageSkill = function () {

                  if(angular.isUndefined(vm.languageSkill.length)){
                    vm.languageSkill = [];
                  }
                    var selectedLangDto = crewProfileDTOFactory.ceateLanguageDTO(vm.model.selectedLanguage.languageCode,
                      vm.model.selectedLanguage.languageDesc);

                    vm.languageSkill.push(selectedLangDto);
                    var index = vm.languageList.indexOf(vm.model.selectedLanguage);
                    if (index > -1) {
                        vm.languageList.splice(index, 1);
                    }
                    vm.model.selectedLanguage = '';


                };
                vm.removeLanguageSkill = function (languageObj) {
                  var msg = [];
                  msg.push('Are you sure to inactivate the '+ languageObj.languageName + ' Language.');
                    var param = {
                      title: 'Confirmation',
                      messages: msg
                    };
                    PopupManager.openModal('CONFIRM_DIALOG', param, inactiveLanguage);

                  function inactiveLanguage(value) {
                    if (!!value) {
                      languageObj.status = 'INA';
                      languageObj.effectiveFromDate = moment().format("DD/MM/YYYY HH:mm");
                    }
                  }

                };

                vm.activateLanguageSkill = function (languageObj) {
                  languageObj.status = 'ACT';
                  languageObj.effectiveFromDate = null;
                }

                vm.$onChanges = function (changeObj) {
                    if (changeObj.crewDetails && changeObj.crewDetails.currentValue && (changeObj.crewDetails.currentValue != changeObj.crewDetails.previousValue)) {
                        vm.tab = 1;
                        adaptCrewData()
                    }
                    if (changeObj.assignedCrewBatches) {
                        var newBatches = changeObj.assignedCrewBatches.currentValue || [];
                        vm.editableCrewBatches = angular.copy(newBatches);
                        // Force multi-select re-creation so it initializes with the selected values
                        vm.batchSelectReady = false;
                        $timeout(function () {
                            vm.batchSelectReady = true;
                        });
                    }
                    if (changeObj.languageSkill && changeObj.languageSkill.currentValue && (changeObj.languageSkill.currentValue != changeObj.languageSkill.previousValue)) {
                        vm.tab = 1;
                        adaptLanguageSkillData()
                    }
                    if (changeObj.crewExclusion && changeObj.crewExclusion.currentValue && (changeObj.crewExclusion.currentValue != changeObj.crewExclusion.previousValue)) {
                        vm.selectedValue = changeObj.crewExclusion.currentValue;
                        $timeout(function () {
                          EventManagerService.notifyEventListeners(EventManagerService.EVENT.MULTI_SELECT_VALUE_CHANGE);
                        },100);

                    }
                    if (changeObj.airportExclusion && changeObj.airportExclusion.currentValue && (changeObj.airportExclusion.currentValue != changeObj.airportExclusion.previousValue)) {
                      vm.selectedValue = changeObj.airportExclusion.currentValue;
                      adaptAirportExclusion()
                    }
                    if (changeObj.airportInclusion && changeObj.airportInclusion.currentValue && (changeObj.airportInclusion.currentValue !== changeObj.airportInclusion.previousValue)) {
                      vm.selectedValue = changeObj.airportInclusion.currentValue;
                      adaptAirportInclusion()
                    }
                    if (changeObj.createNewProfile && changeObj.createNewProfile.currentValue && (changeObj.createNewProfile.currentValue != changeObj.createNewProfile.previousValue)) {
                        createNewProfileDTO()
                    }
                    if (changeObj.designationList && changeObj.designationList.currentValue && changeObj.designationList.currentValue.length > 0) {
                        if (vm.crewDetailsDTO && vm.crewDetailsDTO.designationId) {
                            vm.employmentInfoDTO.designation = _.find(vm.designationList, {designationId: vm.crewDetailsDTO.designationId}) || crewProfileDTOFactory.EmploymentInfoDTO().designation;
                        }
                    }

                };

                vm.getCreDescription = function (type) {
                    var crewType = _.find(vm.crewTypes, {crewTypeCode: type});
                    return crewType.crewTypeDescription;
                };
                vm.onClickExperience = function (e, fleetEx, type) {
                    var findPosition = function () {
                        var H = 'left', V = 'bottom';
                        if ((e.clientX + e.target.offsetWidth + 240) > window.innerWidth) {
                            H = 'left';
                        } else {
                            H = 'right';
                        }

                        return H + '-' + V;
                    };
                    vm.fleetExperiencePopOver = {};
                    vm.model.lastOpenPopOver.popOverFlag = false;
                    vm.model.newPopover.popOverFlag = false;
                    if (type === 'Edit') {
                        fleetEx.popOverFlag =true;
                        vm.fleetExperiencePopOver.crewTypeCode = _.find(vm.crewTypes, {crewTypeCode: fleetEx.crewTypeCode});
                        vm.fleetExperiencePopOver.updateType = 'EDIT';
                        vm.fleetExperiencePopOver.flying = !fleetEx.flying;
                        vm.fleetExperiencePopOver.model = _.find(vm.aircraftTypes, {airCraftType: fleetEx.fleet});
                        vm.fleetExperiencePopOver.version = fleetEx.version;
                        vm.fleetExperiencePopOver.crewProfileFleetExpeId = fleetEx.crewProfileFleetExpeId;
                        var blueLine = {
                            enabled: !fleetEx.blueLine,
                            enabled_old:fleetEx.blueLine,
                            startDate: !fleetEx.blueLine?'':fleetEx.blueLineStartDate,
                            startDate_old: fleetEx.blueLineStartDate,
                            endDate: fleetEx.blueLineEndedDate,
                            startTime: fleetEx.blueLineStartTime,
                            endTime: fleetEx.blueLineEndedTime
                        };
                        vm.fleetExperiencePopOver.blueLineParams = blueLine;
                        vm.fleetExperiencePopOver.fleetClearanceDate = fleetEx.fleetClearanceDate;
                        vm.model.lastOpenPopOver = fleetEx;
                    }
                    else {
                        fleetEx.popOverFlag =true;
                        vm.fleetExperiencePopOver = crewProfileDTOFactory.FleetExperienceDTO();
                        vm.fleetExperiencePopOver.updateType = 'ADD';
                    }
                    vm.model.lastOpenPopOver = fleetEx;
                    vm.fleetExperiencePopOver.position = findPosition();

                };

                vm.onClickBase = function (e, crewBase, type) {
                    var findPosition = function () {
                        var H = 'left', V = 'bottom';
                        if ((e.clientX + e.target.offsetWidth + 240) > window.innerWidth) {
                            H = 'left';
                        } else {
                            H = 'right';
                        }

                        return H + '-' + V;
                    };

                    vm.crewBasePopOver = {};
                    vm.lastCrewBaseOpenPopOver.popOverFlag = false;
                    vm.newCrewBasePopover.popOverFlag = false;
                    if (type === 'Edit') {
                        crewBase.popOverFlag =true;
                        vm.crewBasePopOver.updateType = 'EDIT';
                        vm.crewBasePopOver.crewBase = _.find(vm.baseList, {airPortCode: crewBase.base});
                        vm.crewBasePopOver.crewBaseAssignmentId = crewBase.crewBaseAssignmentId;
                        vm.crewBasePopOver.crewProfileId = crewBase.crewProfileId;
                        vm.crewBasePopOver.effectiveFromDate = crewBase.effectiveFromDate;
                        vm.crewBasePopOver.version = crewBase.version;
                        vm.crewBasePopOver.joinedDate=vm.crewDetails.dateOfJoin;
                        vm.lastCrewBaseOpenPopOver = crewBase;
                        vm.crewBasePopOver.employerHub = _.find(vm.hubs, {hubCode: crewBase.employerHub});
                        vm.crewBasePopOver.postingType = _.find(vm.employmentTypes, {value: crewBase.postingType});
                        vm.crewBasePopOver.remarks = crewBase.remarks;
                    } else {
                        crewBase.popOverFlag =true;
                        vm.crewBasePopOver = crewProfileDTOFactory.crewBaseAssignmentDTO();
                        vm.crewBasePopOver.updateType = 'ADD';
                        vm.crewBasePopOver.joinedDate=vm.crewDetails.dateOfJoin;
                    }
                    vm.lastCrewBaseOpenPopOver = crewBase;
                    //vm.crewBasePopOver.position = findPosition();
                };

                vm.onClickSecondaryBase = function (e, crewBase, type) {
                  var findPosition = function () {
                      var H = 'left', V = 'bottom';
                      if ((e.clientX + e.target.offsetWidth + 240) > window.innerWidth) {
                          H = 'left';
                      } else {
                          H = 'right';
                      }

                      return H + '-' + V;
                  };

                  vm.crewSecondaryBasePopOver = {};
                  vm.lastCrewSecondaryBaseOpenPopOver.popOverFlag = false;
                  vm.newCrewSecondaryBasePopover.popOverFlag = false;
                  if (type === 'Edit') {
                      crewBase.popOverFlag =true;
                      vm.crewSecondaryBasePopOver.updateType = 'EDIT';
                      vm.crewSecondaryBasePopOver.crewBase = _.find(vm.baseList, {airPortCode: crewBase.base});
                      vm.crewSecondaryBasePopOver.crewBaseAssignmentId = crewBase.crewBaseAssignmentId;
                      vm.crewSecondaryBasePopOver.crewProfileId = crewBase.crewProfileId;
                      vm.crewSecondaryBasePopOver.effectiveFromDate = crewBase.effectiveFromDate;
                      vm.crewSecondaryBasePopOver.effectiveToDate = crewBase.effectiveToDate;
                      vm.crewSecondaryBasePopOver.version = crewBase.version;
                      vm.crewSecondaryBasePopOver.joinedDate=vm.crewDetails.dateOfJoin;
                      vm.lastCrewSecondaryBaseOpenPopOver = crewBase;
                      vm.crewSecondaryBasePopOver.employerHub = _.find(vm.hubs, {hubCode: crewBase.employerHub});
                      vm.crewSecondaryBasePopOver.postingType = _.find(vm.employmentTypes, {value: crewBase.postingType});
                      vm.crewSecondaryBasePopOver.remarks = crewBase.remarks;
                  } else {
                      crewBase.popOverFlag =true;
                      vm.crewSecondaryBasePopOver = crewProfileDTOFactory.crewBaseAssignmentDTO();
                      vm.crewSecondaryBasePopOver.updateType = 'ADD';
                      vm.crewSecondaryBasePopOver.joinedDate=vm.crewDetails.dateOfJoin;
                  }
                  vm.lastCrewSecondaryBaseOpenPopOver = crewBase;
                  //vm.crewSecondaryBasePopOver.position = findPosition();
              };

              vm.onClickDateRangeNew = function(e,dateRange,type,component){

              }

              vm.onClickDateRange = function (e, dateRange, type) {
                var findPosition = function () {
                  var H = 'left', V = 'bottom';
                  if ((e.clientX + e.target.offsetWidth + 240) > window.innerWidth) {
                    H = 'left';
                  } else {
                    H = 'right';
                  }

                  return H + '-' + V;
                };

                vm.dateRangePopOver = {};
                vm.lastDateRangeOpenPopOver.popOverFlag = false;
                vm.newDateRangePopover.popOverFlag = false;
                if (type === 'Edit') {
                  // vm.dateRangePopOver.position = position;
                  dateRange.popOverFlag =true;
                  vm.dateRangePopOver.updateType = 'EDIT';
                  vm.dateRangePopOver.dateOfEnd = dateRange.endDate;
                  vm.dateRangePopOver.dateOfStart = dateRange.startDate;
                  vm.dateRangePopOver.crewProfManagePosId = dateRange.crewProfManagePosId;
                  // vm.dateRangePopOver.crewPositionCode = dateRange.managementPosCode;

                  vm.dateRangePopOver.crewPosition = _.find(vm.mgtPositions, {crewPositionCode: dateRange.managementPosCode});
                  // vm.dateRangePopOver.dateOfStart = dateRange.dateOfStart;
                  // vm.crewBasePopOver.version = crewBase.version;
                  vm.lastDateRangeOpenPopOver = dateRange;
                } else {
                  // vm.dateRangePopOver.position = position;
                  dateRange.popOverFlag =true;
                  vm.dateRangePopOver = crewProfileDTOFactory.crewDateRangeForPositionDTO();//add for employee edit
                  vm.dateRangePopOver.updateType = 'ADD';
                }
                vm.lastDateRangeOpenPopOver = dateRange;
                // vm.dateRangePopOver.position = findPosition();
              };

                vm.onClickUpgrade = function (e, upData, type) {
                    vm.model.lastOpenPopOver.popOverFlag = false;
                    vm.model.newPopover.popOverFlag = false;
                    vm.crewUpgradeOriData = angular.copy(upData);
                    vm.crewUpgradePopOver = crewProfileDTOFactory.CrewUpgradeDTO();
                    if (type === 'Add') {
                        vm.crewUpgradePopOver.version = -1;
                        vm.crewUpgradePopOver.updateType = 'Add';
                        vm.crewUpgradePopOver.dateOfJoin=vm.crewDetails.dateOfJoin;

                      upData.popOverFlag = true;
                    }
                    else {
                        vm.crewUpgradePopOver.updateType = 'Edit';
                        vm.crewUpgradePopOver.crewTypeDetails = _.find(vm.crewTypes, {crewTypeCode: upData.crewTypeCode});
                        vm.crewUpgradePopOver.localDateTime = upData.localDateTime;
                        vm.crewUpgradePopOver.dateOfJoin=vm.crewDetails.dateOfJoin;
                        vm.crewUpgradePopOver.crewProfileUpgradeId = upData.crewProfileUpgradeId;
                        vm.crewUpgradePopOver.version = upData.crewUpradeVersion;
                        upData.popOverFlag = true;
                    }
                    vm.model.lastOpenPopOver = upData;
                };

                vm.onTrainingStageStatusUpdate = function (event, trainingStage) {
                  var crewProfileId = vm.crewDetails.crewProfileId;
                  var stageId = trainingStage.crewTypeStageId;
                  var isStageCompleted = event.target.checked;
                  var param = {
                    crewProfileId: crewProfileId,
                    stageId: stageId,
                    isStageCompleted: isStageCompleted ? "Y" : "N"
                  };
                  vm.updateTrainingStageStatus({'trainingStageStatusUpdateRequest': param, trainingStage: trainingStage, isStageCompleted: isStageCompleted});
                }

              vm.onClickTrainingStageUpdate = function (e, stageData, type) {

                vm.selectedTrainingStageRow = stageData;
                vm.trainingStageRows = [];

                vm.model.lastOpenPopOver.popOverFlag = false;
                vm.model.newPopover.popOverFlag = false;
                vm.crewTrainingStageOriData = angular.copy(stageData);
                vm.crewTrainingStagePopOver = crewProfileDTOFactory.CrewTrainingStageDTO();
                if (type === 'Add') {
                  vm.crewTrainingStagePopOver.version = -1;
                  vm.crewTrainingStagePopOver.updateType = 'Add';
                  vm.crewTrainingStagePopOver.dateOfJoin=vm.crewDetails.dateOfJoin;

                  stageData.popOverFlag = true;
                }
                else {
                  vm.crewTrainingStagePopOver.updateType = 'Edit';

                  var enableTrainingStageSequence = false;

                  stageData.instructorsDataList.forEach(function (instructor) {

                    var transformedInstructorTypeCodesArray = instructor.instructorTypeCodes.map(function(code) {
                      return {
                        trainerTypeCode: code,
                        selected: true
                      };
                    });

                    if (instructor.isOrder === "Y") {
                      enableTrainingStageSequence = true;
                    }

                    vm.trainingStageRows.push({
                      trainerTypeDetails: transformedInstructorTypeCodesArray, // Set selected trainer types
                      sectorCount: instructor.sectorCount,
                      isOrder: instructor.isOrder,
                      id: Date.now()
                    });

                  });

                  vm.enableTrainingStageSequence = enableTrainingStageSequence;
                  stageData.popOverFlag = true;
                }
                vm.model.lastOpenPopOver = stageData;
              };

              vm.addTrainingStageRow = function () {
                // Add a new empty rowcrew-profile-controller
                vm.trainingStageRows.push({
                  trainerTypeDetails: null,
                  stageSequenceOrder: null,
                  id: Date.now() // Temporary unique ID
                });
              };

              vm.deleteTrainingStageRow = function (row) {
                // Remove the specified row
                var index = vm.trainingStageRows.indexOf(row);
                if (index > -1) {
                  vm.trainingStageRows.splice(index, 1);
                }
              };

              vm.addUpdateFleetExperience = function () {
                    if(vm.fleetExperience.$invalid){
                        return false;
                    }else{
                        vm.addEditFleetExperience({'fleetDto': vm.fleetExperiencePopOver});
                        vm.fleetExperiencePopOver = {popOverFlag : false};
                        vm.model.lastOpenPopOver= {popOverFlag : false};
                        vm.model.newPopover={popOverFlag : false};
                        upData.popOverFlag = false;
                    }
                };

                vm.addUpdateCrewBase = function () {
                  if(vm.crewBaseForm.$invalid || !(vm.crewBasePopOver.postingType.value) || !(vm.crewBasePopOver.employerHub.hubCode)){
                        return false;
                    }else{
                        // vm.addEditCrewBase({'crewBaseDTO': vm.crewBasePopOver});
                      vm.getEffectedBaseList({'crewBaseDTO': vm.crewBasePopOver});
                      // updateCrewBaseConfirmation(vm.crewBasePopOver);
                    }
                };

                vm.addUpdateSecondaryCrewBase = function () {
                  if(vm.crewSecondaryBaseForm.$invalid || !(vm.crewSecondaryBasePopOver.postingType.value) || !(vm.crewSecondaryBasePopOver.employerHub.hubCode)){
                        return false;
                    }else{
                     vm.addEditCrewSecondaryBase({'crewBaseDTO': vm.crewSecondaryBasePopOver});
//                      vm.addEditCrewSecondaryBase();
                    }
                };

              vm.addACMIRange = function () {

                if(vm.crewAcmiRangeForm.$invalid){
                  return false;
                }else{

                  vm.addCrewACMIDateRange({'dateRangesDTO': vm.addAcmiRangePopover});
                  vm.addAcmiRangePopover = {
                    a320Qualified: true,
                    a321Qualified: true,
                  };
                  vm.closeAddAcmiPopover();
                }
              };

              vm.onEditLayoverAccommodationPreference = function (selectedRow) {
                  vm.editLayoverAccommodationPreference({'selectedRow': selectedRow});
              };

              vm.onDeleteLayoverAccommodationPreference = function (selectedRow) {
                  vm.deleteLayoverAccommodationPreference({'selectedRow': selectedRow});
              };

              vm.addUpdatePositionDateRange = function () {
                if(vm.crewDateRangeForm.$invalid){
                    return false;
                }else{
                    vm.addEditPositionDateRange({'positionDateRangeDTO': vm.dateRangePopOver});
                }
              };

                vm.deleteCrewBase = function () {
                    vm.deleteCrewBaseController({'crewBaseDTO': vm.crewBasePopOver});
                };

                vm.deleteCrewSecondaryBase = function () {
                    vm.deleteCrewSecondaryBaseController({'crewBaseDTO': vm.crewSecondaryBasePopOver});
                };

              vm.deletePositionDateRange = function () {
                vm.deleteDateRangeController({'positionDateRangeDTO': vm.dateRangePopOver});
              };

                vm.changeFlyingMode = function () {
                    vm.fleetExperiencePopOver.flying = !vm.fleetExperiencePopOver.flying;
                };

                vm.addEditCrewUpgradeData = function () {
                    vm.crewUpgrade.$submitted = true;
                    if (vm.crewUpgrade.$valid) {
                        if (vm.crewUpgradePopOver.updateType === 'Edit' && vm.crewUpgradeOriData.crewTypeCode !== vm.crewUpgradePopOver.crewTypeDetails.crewTypeCode) {
                            vm.crewUpgradePopOver.crewProfCrewTypeChanged = true;
                        }
                    	if(isUpGradeOrDownGradeValid(vm.crewUpgradePopOver) && !isDuplicateRecordsExist(vm.crewUpgradePopOver)){
                        	vm.addEditCrewUpgrade({'upgradeDTO': vm.crewUpgradePopOver})
                        }
                    }

                };

              vm.deleteUpgradeData = function (){
                if (!isFirstUpgradeRecord()) {
                  if(vm.crewUpgradePopOver.updateType === 'Edit'){
                    vm.crewUpgradePopOver.previousCrewType = getPreviousUpgratedCrewType(vm.crewUpgradePopOver);
                    vm.deleteCrewUpgrade({'upgradeDTO': vm.crewUpgradePopOver});
                  }else{
                    //close add popup box and clear data
                    angular.element(".add-box").trigger('click');
                    vm.crewUpgradePopOver = {popOverFlag : false};
                    vm.model.lastOpenPopOver= {popOverFlag : false};
                    vm.model.newPopover={popOverFlag : false};
                  }
                }else{
                  MessageService.error("Initial Upgraded Record Cannot be Deleted");
                }
              }

              function adaptTrainingStageData(trainingStageRows, selectedTrainingStageRow) {
                var adaptedData = {
                  crewTypeStageId: selectedTrainingStageRow.crewTypeStageId,
                  stageName: selectedTrainingStageRow.stageName,
                  stageSequence: selectedTrainingStageRow.stageSequenceOrder,
                  crewTypeCode: selectedTrainingStageRow.crewTypeCode,
                  status: selectedTrainingStageRow.status,
                  stageVersion: 1,
                  crewProfileId: vm.crewDetails.crewProfileId,
                  instructorTypes: []
                };

                trainingStageRows.forEach(function(row, index) {
                  row.trainerTypeDetails.forEach(function(trainer) {
                    adaptedData.instructorTypes.push({
                      instructorTypeCode: trainer.trainerTypeCode,
                      sectorCount: row.sectorCount,
                      crewProfileId: vm.crewDetails.crewProfileId,
                      sequenceOrder: index + 1,
                      instructorTypeCodeVersion: -1,
                      isOrder: vm.enableTrainingStageSequence ? 'Y' : 'N'
                    });
                  });
                });

                return adaptedData;
              }

              vm.addEditTrainingStageData = function () {
                vm.crewTrainingStage.$submitted = true;
                if (vm.crewTrainingStage.$valid) {
                  var adaptedData = adaptTrainingStageData(vm.trainingStageRows, vm.selectedTrainingStageRow);
                  vm.addEditTrainingStage({'trainingStageDTO': adaptedData});
                }
              };

                //get previous upgrated crew Type
                function getPreviousUpgratedCrewType(upgradeData){
                	var prevUpgradeCrewType = null;
                	if(!!vm.crewUpgradeData && vm.crewUpgradeData.length> 0){
                		prevUpgradeCrewType = vm.crewUpgradeData[0].crewTypeCode;
                		 for(var i=1; i< vm.crewUpgradeData.length; i++){
                			 if(vm.crewUpgradeData[i].crewProfileUpgradeId == upgradeData.crewProfileUpgradeId){
                				 prevUpgradeCrewType = vm.crewUpgradeData[i-1].crewTypeCode;
                				 return prevUpgradeCrewType;
                			 }
                		 }
                	}
                	return prevUpgradeCrewType;
                }

                //check duplicate update record exist
                function isDuplicateRecordsExist(crewUpgradePopOver){
                	var duplicateRecordFound = false;
                	if(!!vm.crewUpgradeData && vm.crewUpgradeData.length> 0){
                		var similarUpgrade = _.find(vm.crewUpgradeData, {localDateTime: crewUpgradePopOver.localDateTime});
                		if(!!similarUpgrade && similarUpgrade.crewTypeCode == crewUpgradePopOver.crewTypeDetails.crewTypeCode){
                			duplicateRecordFound = true;
                			MessageService.error("Duplicate Upgrade Record Exists");
                		}
                	}
                	return duplicateRecordFound;
                };

                //check upgrade or down grade is valid
                function isUpGradeOrDownGradeValid(crewUpgradePopOver){
                	var downGradeValid = true;
                	var currentUpgradedCrewType = crewUpgradePopOver.crewTypeDetails.crewTypeCode;
                	var lastUpgradedCrewType = vm.crewUpgradePopOver.updateType === 'Edit'? vm.crewUpgradeOriData.crewTypeCode : getHighestUpgradedCrewType();
                	if(lastUpgradedCrewType != null){
                		//if crew has been down graded
                		if(getCrewRankByCrewTypeCode(lastUpgradedCrewType) < getCrewRankByCrewTypeCode(currentUpgradedCrewType)){
                    		var currentCrewCategory = _.find(vm.crewTypes, {crewTypeCode: currentUpgradedCrewType}).crewTypeMasterCode;
                    		var lasthighestCrewCategory = _.find(vm.crewTypes, {crewTypeCode: lastUpgradedCrewType}).crewTypeMasterCode;
                    		//if down graded to lower crew category
                    		if(currentCrewCategory != lasthighestCrewCategory){
                    			downGradeValid = false;
                    			MessageService.error("Crew Cannot be Down Graded To The Lower Crew Category");
                    		}
                    	}
                    	// else if(!isUpgradedDateValid(crewUpgradePopOver)){
                    	// 	downGradeValid = false;
                    	// 	MessageService.error("Upgrade Date Cannot be Lower Than First Upgrade Date");
                    	// }
                	}
                	return downGradeValid;
                };

                function isUpgradedDateValid(crewUpgradePopOver){
                	var validUpgradeDate = true;
                	var currentUpgradeDate = new Date(moment(crewUpgradePopOver.localDateTime, 'DD/MM/YYYY').format('MM/DD/YYYY'));
                	var firstUpgradeDate = null;
                	if(!!vm.crewUpgradeData && vm.crewUpgradeData.length>0){
                		firstUpgradeDate = new Date(moment(vm.crewUpgradeData[0].localDateTime, 'DD/MM/YYYY').format('MM/DD/YYYY'));
                		if(currentUpgradeDate < firstUpgradeDate){
                			validUpgradeDate = false;
                		}
                	}
                	return validUpgradeDate;
                }

                //check whether the first upgrade record
                function isFirstUpgradeRecord(){
                	var firstUpgradeRecord = false;
                	if(!!vm.crewUpgradeData && vm.crewUpgradeData.length>0){
                		if(vm.crewUpgradeData[0].crewTypeCode == vm.crewUpgradeOriData.crewTypeCode
                				&& vm.crewUpgradeData[0].localDateTime == vm.crewUpgradeOriData.localDateTime ){
                			firstUpgradeRecord = true;
                		}
                	}
                	return firstUpgradeRecord;
                }

                //get crew upgraded highest rank
                function getHighestUpgradedCrewType(){
                	var highestCrewType = null;
                	if(!!vm.crewUpgradeData && vm.crewUpgradeData.length> 0 ){
                		highestCrewType = vm.crewUpgradeData[0];
                		for(var i=1; i<vm.crewUpgradeData.length ;i++){
                    		if(getCrewRankByCrewTypeCode(highestCrewType) > getCrewRankByCrewTypeCode(vm.crewUpgradeData[i].crewTypeCode)){
                    			highestCrewType = vm.crewUpgradeData[i].crewTypeCode;
                    		}
                    	}
                	}
                	return highestCrewType;
                }

                //get rank by crew type code from the crew type list
                function getCrewRankByCrewTypeCode(crewTypeCode){
                	var crewRank = Number.MAX_VALUE;
                	if(!!crewTypeCode){
                		var crewType = _.find(vm.crewTypes, {crewTypeCode: crewTypeCode});
                		if(!!crewType){
                			crewRank = crewType.rank;
                		}
                	}
                	return crewRank;
                }

                vm.closeUpgradePopover = function () {
                    $timeout(function(){
                        vm.model.newPopover.popOverFlag = false;
                        vm.model.lastOpenPopOver.popOverFlag = false;
                        if(vm.crewUpgradePopOver.updateType.toUpperCase()!=='EDIT'){
                            angular.element(".add-box").trigger('click');
                        };
                    })
                };

                vm.closeTrainingStagePopover = function () {
                  $timeout(function(){
                    vm.model.newPopover.popOverFlag = false;
                    vm.model.lastOpenPopOver.popOverFlag = false;
                    if(vm.crewTrainingStagePopOver.updateType.toUpperCase()!=='EDIT'){
                      angular.element(".add-box").trigger('click');
                    };
                  })
                };

                vm.closeExpPopover = function () {
                    $timeout(function(){
                        vm.model.newPopover.popOverFlag = false;
                        vm.model.lastOpenPopOver.popOverFlag = false;
                        if(vm.fleetExperiencePopOver.updateType.toUpperCase()=='ADD'){
                            angular.element(".add-fleet-exp").trigger('click');
                        };
                    })
                };

                vm.closeBasePopover = function () {
                    $timeout(function(){
                        vm.newCrewBasePopover.popOverFlag = false;
                        vm.lastCrewBaseOpenPopOver.popOverFlag = false;
                        if(vm.crewBasePopOver.updateType.toUpperCase()=='ADD'){
                            angular.element(".add-crew-base").trigger('click');
                        };
                    })
                };

                vm.closeSecondaryBasePopover = function () {
                    $timeout(function(){
                        vm.newCrewSecondaryBasePopover.popOverFlag = false;
                        vm.lastCrewSecondaryBaseOpenPopOver.popOverFlag = false;
                        if(vm.crewBasePopOver.updateType.toUpperCase()=='ADD'){
                            angular.element(".add-crew-base").trigger('click');
                        };
                    })
                };

              vm.closeAddAcmiPopover = function () {
                $timeout(function(){
                  vm.newACMIRangePopover.popOverFlag = false;
                  vm.addAcmiRangePopover = {
                    a320Qualified: true,
                    a321Qualified: true,
                  }
                })
              };

              vm.closeDateRangePopover = function () {
                $timeout(function(){
                  vm.newDateRangePopover.popOverFlag = false;
                  vm.lastDateRangeOpenPopOver.popOverFlag = false;
                  if(vm.dateRangePopOver.updateType.toUpperCase()=='ADD'){
                    angular.element(".add-date-range").trigger('click');
                  };
                })
              };

                vm.openCrewBaseHistory = function () {
                    vm.openCrewBaseHistoryController();
                }

                vm.viewPreferenceHistory = function () {
                    vm.openCrewPreferenceHistoryController();
                }

                vm.openCrewSecondaryBaseHistory = function () {
                    vm.openCrewSecondaryBaseHistoryController();
                }


              vm.openCrewACMIOperationsHistory = function () {
                vm.openCrewACMIOperationsHistoryController();
              }

              vm.changeEditStatus = function () {
                  vm.model.isEditACMIData = !vm.model.isEditACMIData;
              }

              vm.openPositionDateRangeHistory = function () {
                // vm.openCrewBaseHistoryController();
              }

                function findCrewIndex(data) {
                    for (var i = 0; i < vm.allCrewList.length; i++) {
                        if (vm.allCrewList[i].crewProfileId === data.excludedCrewProfileId) {
                            return i;
                        }
                    }
                    return -1;
                }

              function adaptCrewExclusion() {
                angular.forEach(vm.crewExclusion, function (value) {

                  var index = findCrewIndex(value);
                  if (index > -1) {
                    vm.allCrewList.splice(index, 1);
                  }

                });

                var temp = angular.copy(vm.crewTypes);

                angular.forEach(temp, function (type) {
                  type.crewExclusion = [];
                  angular.forEach(vm.crewExclusion, function (exclusion) {
                    if (exclusion.crewTypeCode === type.crewTypeCode) {
                      type.crewExclusion.push(exclusion);

                    }
                  });
                });
                vm.adaptedCrewExclusion = temp;
              }

                function findAirportIndex(data) {
                    for (var i = 0; i < vm.airports.length; i++) {
                        if (vm.airports[i].airPortCode === data) {
                            return i;
                        }
                    }
                    return -1;
                }

                function adaptAirportExclusion() {
                    angular.forEach(vm.airportExclusion, function (value) {

                         var index = findAirportIndex(value);
                         if (index > -1) {
                             vm.airports.splice(index, 1);
                         }

                     });
                 }

                function adaptAirportInclusion() {
                  angular.forEach(vm.airportInclusion, function (value) {

                    var index = findAirportIndex(value);
                    if (index > -1) {
                      vm.airports.splice(index, 1);
                    }

                  });
                }

                 vm.addCrewExclusive = function () {


                     angular.forEach(vm.adaptedCrewExclusion, function (type) {
                         if (vm.model.exclusiveCrew.crewType === type.crewTypeCode) {
                             var temp = {};
                             temp.excludedCrewProfileId = vm.model.exclusiveCrew.crewProfileId;//vm.model.exclusiveCrew.crewId;
                             temp.crewName = vm.model.exclusiveCrew.displayName;
                             temp.crewTypeCode = vm.model.exclusiveCrew.crewType;
                             temp.joinedDate = vm.model.exclusiveCrew.dateOfJoin;
                             // temp.crewProfileId = vm.model.exclusiveCrew.crewProfileId
                             type.crewExclusion.push(temp);
                         }
                     });
                     var index = vm.allCrewList.indexOf(vm.model.exclusiveCrew);
                     if (index > -1) {
                         vm.allCrewList.splice(index, 1);
                     }
                     vm.model.exclusiveCrew = ''
                 };

                 vm.removeCrewExclusion = function (parentCode, exclusiveDTO, childID) {

                    angular.forEach(vm.adaptedCrewExclusion, function (type) {
                     if (parentCode === type.crewTypeCode) {

                        angular.forEach(type.crewExclusion,function(excution){

                          if(excution.excludedCrewProfileId = exclusiveDTO.excludedCrewProfileId){
                            var childIndex = type.crewExclusion.indexOf(excution);
                            if (childIndex > -1) {
                              type.crewExclusion.splice(childIndex, 1);
                                    }
                          }

                        });

                        if(type.crewExclusion.length == 0){
                          var parenIndex = vm.adaptedCrewExclusion.indexOf(type);
                          if (parenIndex > -1) {
                            vm.adaptedCrewExclusion.splice(type, 1);
                                  }
                        }


                       }
                   });

                     vm.allCrewList.push(exclusiveDTO);

                 };

                 vm.removeAirportExclusion = function (selectedAirport, index) {
                   delete vm.airportExclusion[index];
                   vm.model.isDisableExclusionSave = false;
                   var count = 0;
                   angular.forEach(vm.airportExclusion, function (exclusion) {
                     if (exclusion.airportListIndex < selectedAirport.airportListIndex) {
                       count += 1;
                     }
                   });
                   vm.airports.splice(selectedAirport.airportListIndex - count, 0, selectedAirport.airport);
                 };

                 vm.saveExclusion = function () {

                   var excludedProfileIds = [];
                   angular.forEach(vm.crewExclusion, function (exclusion) {
                     var crewExclude = {}
                     crewExclude.crewId = exclusion.valueFieldName;
                     crewExclude.exclusionStartDate = exclusion.startedDate;
                     crewExclude.changed = exclusion.changed;

                     excludedProfileIds.push(crewExclude);
                   });

                   var airportExclusions = [];
                   angular.forEach(vm.airportExclusion, function (exclusion) {
                     var airportExclude = {}
                     airportExclude.airportCode = exclusion.valueFieldName;
                     airportExclude.exclusionStartDate = exclusion.startedDate;
                     airportExclude.changed = exclusion.changed;

                     airportExclusions.push(airportExclude);
                   });

                   vm.saveAddEditExclusion({
                     exclusionDTO: {
                       crewExclusion: excludedProfileIds,
                       airportExclusion: airportExclusions
                     }
                   });
                   vm.model.isDisableExclusionSave = true;
                   angular.forEach(vm.airportExclusion, function (exclusion) {
                     // exclusion.airportCode = "XXX";
                     exclusion.changed = false;
                   });
                   angular.forEach(vm.crewExclusion, function (exclusion) {
                     exclusion.changed = false;
                   });
                 };

                 vm.addAirportExclusive = function () {
                   var airportExcludeWithDate = {};
                   var index = vm.airports.indexOf(vm.model.airportExclusion);
                   airportExcludeWithDate.airportCode = vm.model.airportExclusion.airPortCode;
                   var month = new Date().getMonth()+1;
                   var count = 0;
                   angular.forEach(vm.airportExclusion, function (exclusion) {
                       if (exclusion.airportListIndex < index) {
                         count += 1;
                       }
                   });
                   airportExcludeWithDate.exclusionStartDate = new Date().getDate()+"/"+month+"/"+new Date().getFullYear();
                   airportExcludeWithDate.changed = true;
                   airportExcludeWithDate.airportListIndex = index + count;
                   airportExcludeWithDate.airport = vm.model.airportExclusion;

                   vm.airportExclusion.push(airportExcludeWithDate);
                   if (index > -1) {
                     vm.airports.splice(index, 1);
                   };
                   vm.model.airportExclusion = '';
                   vm.model.isDisableExclusionSave = false;
                 };

               vm.onClickExcludeAirportEditDate = function (e, exAirport, type) {

                 angular.forEach(vm.airportExclusion, function (value) {
                   if (vm.airportExclusionPopOver && value.airportCode === exAirport.airportCode&& value.airportCode === vm.airportExclusionPopOver.airportCode) {
                     if (vm.airportExclusionPopOver.exclusionStartDate !== exAirport.exclusionStartDate) {
                       if (vm.airportExclusionPopOver.exclusionStartDate === "") {
                         value.exclusionStartDate = exAirport.exclusionStartDate;
                         value.changed = true;
                       } else {
                         value.exclusionStartDate = vm.airportExclusionPopOver.exclusionStartDate;
                         value.changed = true;
                       }
                       vm.model.isDisableExclusionSave = false;
                     }

                   }
                 });
                 vm.model.lastAirportExOpenPopOver.popOverFlag = false;
                 vm.model.newAirportExPopover.popOverFlag = false;
                 vm.airportExclusionPopOver = {};
                 vm.airportExclusionPopOver.updateType = 'Edit';
                 vm.airportExclusionPopOver.exclusionStartDate = exAirport.exclusionStartDate;
                 vm.airportExclusionPopOver.airportCode = exAirport.airportCode;
                 exAirport.popOverFlag = true;

                 vm.model.lastAirportExOpenPopOver = exAirport;
               };

              vm.saveInclusion = function () {
                var airportInclusions = [];
                angular.forEach(vm.airportInclusion, function (inclusion) {
                  var airportInclude = {
                    airportCode: inclusion.valueFieldName,
                    inclusionStartDate: inclusion.startedDate,
                    changed: inclusion.changed
                  }
                  airportInclusions.push(airportInclude);
                });

                vm.saveAddEditInclusion({
                  inclusionDTO: {
                    airportInclusion: airportInclusions
                  }
                });
                vm.model.isDisableInclusionSave = true;
                angular.forEach(vm.airportInclusion, function (inclusion) {
                  inclusion.changed = false;
                });
              };

              vm.addAirportInclusive = function () {
                var airportIncludeWithDate = {};
                var index = vm.airports.indexOf(vm.model.airportInclusion);
                airportIncludeWithDate.airportCode = vm.model.airportInclusion.airPortCode;
                var month = new Date().getMonth()+1;
                var count = 0;
                angular.forEach(vm.airportInclusion, function (inclusion) {
                  if (inclusion.airportListIndex < index) {
                    count += 1;
                  }
                });
                airportIncludeWithDate.inclusionStartDate = new Date().getDate()+"/"+month+"/"+new Date().getFullYear();
                airportIncludeWithDate.changed = true;
                airportIncludeWithDate.airportListIndex = index + count;
                airportIncludeWithDate.airport = vm.model.airportInclusion;

                vm.airportInclusion.push(airportIncludeWithDate);
                if (index > -1) {
                  vm.airports.splice(index, 1);
                };
                vm.model.airportInclusion = '';
                vm.model.isDisableInclusionSave = false;
              };

              vm.uploadFile = function () {
                     var filename = event.target.files[0];


                     var uploadUrl = "/admin/aeroLineCrewAdmin/crewService/save/profileImage?crewId=" + vm.crewDetails.crewId;

                     var formdata = new FormData();
                     formdata.append('fileMeta', filename);

                     $http.post(uploadUrl, formdata, {
                             transformRequest: angular.identity,
                             headers: {'Content-Type': undefined}
                         })
                         .success(function () {
                             MessageService.success(MessageService.MESSAGES.CREW_PROFILE.EDIT_SUCCESS);
                             vm.crewDetails.blockFlag = 'personal';
                             vm.editSaveProfile();
                         })

                         .error(function (response) {
                             MessageService.error(response.error);
                         });
                 };

                 vm.selectAllValidations = function () {
                     angular.forEach(vm.defaultValidations, function (validation) {
                         validation.isAssigned = 'Y'
                     });
                 };

                 vm.unselectAllValidations = function () {
                     var mandatory = [];
                     var msg = [];

                     angular.forEach(vm.defaultValidations, function (validation) {
                         if (validation.isMandatory == 'Y' && validation.isAssigned == 'Y') {
                             mandatory.push(validation.validationCode);
                         }
                     });

                     if (mandatory.length > 0) {
                         if(mandatory.length === 1) {
                             msg.push(mandatory.join(', ') + ' is a mandatory validation');
                         } else {
                             msg.push(mandatory.join(', ') + ' are mandatories validation');
                         }
                         msg.push(MessageService.MESSAGES.COMMON.CONFIRM_CONTINUE);
                         var param = {
                             title: 'Confirmation',
                             messages: msg
                         };
                         PopupManager.openModal('CONFIRM_DIALOG', param, onMandatoryRemoveClose);
                     }

                     function onMandatoryRemoveClose(param) {
                         if (angular.isUndefined(param)) { //If cancelled rollback
                             angular.forEach(vm.defaultValidations, function (validation) {
                                 if (validation.isMandatory == 'Y' && validation.isAssigned == 'Y' ) {
                                     validation.isAssigned = 'Y';
                                 }
                             });
                         } else {
                             angular.forEach(vm.defaultValidations, function (validation) {
                                 validation.isAssigned = 'N';
                             });
                         }
                     }
                 };

                 function createNewProfileDTO() {
                     if (!!vm.createNewProfile) {
                         //reset default validations, if available
                         vm.defaultValidations = [];

                         vm.personalInfoDTO = crewProfileDTOFactory.PersonalInfoDTO();
                         vm.crewInfoDTO = crewProfileDTOFactory.CrewInfoDTO();
                         vm.employmentInfoDTO = crewProfileDTOFactory.EmploymentInfoDTO();
                         vm.primaryContactInfo = crewProfileDTOFactory.PrimaryContactDTO();
                         vm.secondaryContactInfo = crewProfileDTOFactory.SecondaryContactDTO();
                         vm.kinContactInfo = crewProfileDTOFactory.KinContactDTO();
                         vm.traineeTypeInfo = crewProfileDTOFactory.TraineeTypeInfoDTO();
                         vm.webAccessInfoDTO = crewProfileDTOFactory.WebAccessDTO();
                         var contractInfo = _.find(vm.offContracts, {default: true}) || [];
                       vm.employmentInfoDTO.contractInfo.contractCode = contractInfo.contractCode;
                         vm.model.singleSignOn.isSSOEnabled=false;

                         vm.model.isDisablePersonalInfo = false;
                         vm.model.isDisableCrewInfo = false;
                         vm.model.isDisabledEmpInfo = false;
                         vm.model.isWebAccessInfo = false;
                         vm.model.isEditKingContact = false;
                         vm.model.isDisabledPrimaryContact = false;
                         vm.model.isEditSingleSignOn = false;
                         vm.model.isEditTrainerType = false;
                         vm.model.showcontact = false;
                         vm.webAccessInfo.$submitted =  false;
                         vm.isWebAccessInfo = true;
                     }

                 }

                 function getSelectedValidations() {
                     var selected = [];
                     angular.forEach(vm.defaultValidations, function (validation, key) {
                         if (validation.isAssigned == 'Y') {
                             selected.push(validation.validationId);
                         }
                     });
                     return selected;
                 }

               function getSelectedValidationCodes() {
                 var selected = [];
                 angular.forEach(vm.defaultValidations, function (validation, key) {
                   if (validation.isAssigned == 'Y') {
                     selected.push(validation.validationCode);
                   }
                 });

                 return selected;
               }

                 function setFormData() {
                     vm.crewDetails.blockFlag = 'newCrew'
                     vm.crewDetails.firstName = vm.personalInfoDTO.firstName;
                     vm.crewDetails.middleName = vm.personalInfoDTO.middleName;
                     vm.crewDetails.lastName = vm.personalInfoDTO.lastName;
                     vm.crewDetails.lastNameWithInitials = vm.personalInfoDTO.lastNameWithInitials;
                     vm.crewDetails.callName = vm.personalInfoDTO.callName;
                     vm.crewDetails.religion = vm.personalInfoDTO.religion;
                     vm.crewDetails.gender = vm.personalInfoDTO.gender && vm.personalInfoDTO.gender.code;
                     vm.crewDetails.civilStatus = vm.personalInfoDTO.civilStatus && vm.personalInfoDTO.civilStatus.code;
                     vm.crewDetails.status = vm.personalInfoDTO.status;
                     vm.crewDetails.trainee = vm.personalInfoDTO.trainee;
                     vm.crewDetails.seniorPilot = vm.personalInfoDTO.seniorPilot;
                     vm.crewDetails.probation = vm.personalInfoDTO.probation;
                     vm.crewDetails.wetLeaseCrew = vm.personalInfoDTO.wetLeaseCrew;
                     vm.crewDetails.acmiStartDate = vm.personalInfoDTO.acmiStartDate;
                     vm.crewDetails.blueLine = vm.personalInfoDTO.blueLine;
                     vm.crewDetails.otherHub = vm.personalInfoDTO.otherHub;
                     vm.crewDetails.coverPilotRequired = vm.personalInfoDTO.coverPilotRequired;
                     vm.crewDetails.lvp = vm.personalInfoDTO.lvp;
                     vm.crewDetails.trn = vm.personalInfoDTO.trn;
                     vm.crewDetails.etop = vm.personalInfoDTO.etop;
                     vm.crewDetails.rhs = vm.personalInfoDTO.rhs;
                     vm.crewDetails.dob = vm.personalInfoDTO.dob;
                     vm.crewDetails.crewOperType = vm.personalInfoDTO.crewOperType && vm.personalInfoDTO.crewOperType.operTypeCode;
                     vm.crewDetails.flying = vm.personalInfoDTO.flying;

                     vm.crewDetails.crewId = vm.crewInfoDTO.crewId;
                     vm.crewDetails.crewTypeCode = vm.crewInfoDTO.crewTypeCode.crewTypeCode;
                     vm.crewDetails.group = vm.crewInfoDTO.group.groupCode;
                     vm.crewDetails.batchCode = vm.crewInfoDTO.batchCode.crewBatchCode;
                     vm.crewDetails.boxNumber = vm.crewInfoDTO.boxNumber;
                     vm.crewDetails.uId = vm.crewInfoDTO.uId;
                     vm.crewDetails.newStaffId = vm.crewInfoDTO.newStaffId;
                     vm.crewDetails.ucid = vm.crewInfoDTO.ucid;
                     if(vm.crewInfoDTO.alvGroup) vm.crewDetails.alvGroupCode = vm.crewInfoDTO.alvGroup.alvGroupCode;

                    vm.crewDetails.dateOfContract = vm.employmentInfoDTO.dateOfContract;
                    vm.crewDetails.flexiDateOfContract = vm.employmentInfoDTO.flexiDateOfContract;
                    vm.crewDetails.dateOfJoin = vm.employmentInfoDTO.dateOfJoin;
                    vm.crewDetails.crewBase = vm.employmentInfoDTO.crewBase.airPortCode;
                    vm.crewDetails.passportDateOfIssue = vm.employmentInfoDTO.passportDateOfIssue;
                    vm.crewDetails.passportNumber = vm.employmentInfoDTO.passportNumber;
                    vm.crewDetails.passportDateOfExpiry = vm.employmentInfoDTO.passportDateOfExpiry;
                    vm.crewDetails.nationalityCode = vm.employmentInfoDTO.nationalityCode.code;
                    vm.crewDetails.crewPosition = vm.employmentInfoDTO.crewPosition.crewPositionCode;
                    vm.crewDetails.crewPositionList = vm.employmentInfoDTO.crewPositionList;
                    vm.crewDetails.lastWorkingDay = vm.employmentInfoDTO.lastWorkingDay;
                    vm.crewDetails.civilId = vm.employmentInfoDTO.civilId;
                    vm.crewDetails.employerHub = vm.employmentInfoDTO.employerHub.hubCode;
                    vm.crewDetails.contractCode = vm.employmentInfoDTO.contractInfo.contractCode;

                    vm.crewDetails.residenceAddLine1 = vm.primaryContactInfo.residenceAddLine1;
                    vm.crewDetails.residenceAddLine2 = vm.primaryContactInfo.residenceAddLine2;
                    vm.crewDetails.residencePostalCode = vm.primaryContactInfo.residencePostalCode;
                    vm.crewDetails.stateProvience = vm.primaryContactInfo.stateProvience;
                    vm.crewDetails.primaryResidenceNo = vm.primaryContactInfo.primaryResidenceNo;
                    vm.crewDetails.primaryBusinessNo = vm.primaryContactInfo.primaryBusinessNo;
                    vm.crewDetails.primaryMobileNo = vm.primaryContactInfo.primaryMobileNo;
                    vm.crewDetails.primaryEmail = vm.primaryContactInfo.primaryEmail;
                    vm.crewDetails.swapContact = vm.primaryContactInfo.swapContact;

                    vm.crewDetails.secondaryResidenceNo = vm.secondaryContactInfo.secondaryResidenceNo;
                    vm.crewDetails.secondaryBusinessNo = vm.secondaryContactInfo.secondaryBusinessNo;
                    vm.crewDetails.secondaryMobileNo = vm.secondaryContactInfo.secondaryMobileNo;
                    vm.crewDetails.secondaryEmail = vm.secondaryContactInfo.secondaryEmail;

                    vm.crewDetails.kinName = vm.kinContactInfo.kinName;
                    vm.crewDetails.kinRelationship = vm.kinContactInfo.kinRelationship;
                    vm.crewDetails.kinMobileNo = vm.kinContactInfo.kinMobileNo;
                    vm.crewDetails.kinAddLine1 = vm.kinContactInfo.kinAddLine1;

                    vm.crewDetails.loginId = vm.webAccessInfoDTO.loginId;
                    vm.crewDetails.version = null;
                    vm.crewDetails.loginUserVersion = null;
                    vm.crewDetails.crewProfileId = '';
                    vm.crewDetails.passwordInfo = AuthService.getCrewProfileChangePasswordRequest(vm.webAccessInfoDTO.loginId, vm.webAccessInfoDTO.password);
                    vm.crewDetails.isSingleSignOnEnabled = vm.model.singleSignOn.isSSOEnabled ? 'Y' : 'N';
                    vm.crewDetails.defaultValidationIds = getSelectedValidations();
                    vm.crewDetails.defaultValidationCodes = getSelectedValidationCodes();
                    vm.crewDetails.languageCodes = vm.languageSkill;
                    vm.crewDetails.assignedRoleIds = [];
                }

                function createNewCrewProfile() {
                    vm.personalInfo.$submitted = true;
                    vm.crewInfo.$submitted = true;
                    vm.employmentInfo.$submitted = true;
                    vm.primaryContact.$submitted = true;
                    vm.kinContact.$submitted = true;
                    vm.secondaryContact.$submitted = true;
                    vm.traineeInfo.$submitted = true;
                    vm.webAccessInfo.$submitted = true;

                    if (!vm.model.singleSignOn.isSSOEnabled && vm.webAccessInfoDTO.password !== vm.webAccessInfoDTO.confirmPassword) {
                    	vm.model.passwordMissMatch = true;
                    }
                    if(!vm.model.singleSignOn.isSSOEnabled && vm.webAccessInfoDTO.password && !vm.webAccessInfoDTO.password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,12}$/)){
                          vm.passwordRegexMisMatch = true;
                    }

                    if (vm.personalInfo.$valid &&
                        !vm.dobAfterToday &&
                        vm.crewInfo.$valid &&
                        vm.employmentInfo.$valid &&
                        !vm.passportIssuedDateAfterToday &&
                        vm.primaryContact.$valid &&
                        vm.kinContact.$valid &&
                        vm.secondaryContact.$valid &&
                        vm.traineeInfo.$valid &&
                        vm.webAccessInfo.$valid &&
                        (vm.model.singleSignOn.isSSOEnabled || vm.webAccessInfoDTO.password === vm.webAccessInfoDTO.confirmPassword)) {
                        setFormData();
                        vm.editSaveProfile();
                        vm.model.passwordMissMatch = false;
                        vm.passwordRegexMisMatch = false;
                    }
                }

                vm.clickOnMonthNavigation= function (type){
                	vm.onMonthNavigationClick({'type': type})
                }
                vm.clickOnCrewNavigation = function (option) {
                    vm.crewNavigation({'type': option});
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.TOOLBAR.OTHER_HUB_HOURS.CLEAR);
                };

                vm.saveDefaultValidations = function () {
                    vm.onDefaultValidationSave();
                };

                vm.onValidationChange = function (validationType) {
                    var msg = [];
                    msg.push(validationType.validationDesc + ' is a mandatory validation')
                    msg.push(MessageService.MESSAGES.COMMON.CONFIRM_CONTINUE);
                    if (validationType.isMandatory == 'Y' && validationType.isAssigned == 'N') {
                        var param = {
                            title: 'Confirmation',
                            messages: msg
                        };
                        PopupManager.openModal('CONFIRM_DIALOG', param, onMandatoryRemoveClose);
                    }

                    function onMandatoryRemoveClose(param) {
                        if (angular.isUndefined(param)) { //If cancelled rollback
                            validationType.isAssigned = 'Y';
                        }
                    }
                };

                vm.onCrewTypeSelected = function () {
                    if (vm.createNewProfile && !!vm.crewInfoDTO.crewTypeCode.crewTypeCode) {
                        vm.onCrewTypeChange({crewTypeCode: vm.crewInfoDTO.crewTypeCode.crewTypeCode});
                        vm.passwordRegexMisMatch = false;
                    }
                };

                vm.onCrewIdChanged = function () {
                  if (vm.createNewProfile) {
                    vm.model.isWebAccessInfo = true;
                    vm.webAccessInfoDTO = vm.webAccessInfoDTO || {};
                    // Default password (must satisfy your regex)
                    vm.webAccessInfoDTO.loginId = vm.crewInfoDTO.crewId;
                  }

                };

                function setMinDate(){
                	//set min date of date picker as crew joined date
                    if(!!vm.employmentInfoDTO && !!vm.employmentInfoDTO.dateOfJoin){
                    	var momentString = moment(vm.employmentInfoDTO.dateOfJoin, 'DD/MM/YYYY').format('MM/DD/YYYY');
                    	vm.upgradeDateOption.minDate = new Date(momentString);
                    }
                };

                vm.onAddMemoClick = function(params){
                	vm.addMemoClicked.call(this,{params: params});
                }

                vm.assignDirectEvent = function(param,type) {
                    vm.onDirectActionClicked({param: param, type: type})
                }

                vm.onSendAlertClick = function (param) {
                    vm.onSendAlertClicked({param: param});
                }

                vm.onSendSmsClick = function(param) {
                    vm.onSendSmsClicked.call(this, {param: param});
                }

                vm.onShowHistoryClick = function(param) {
                    vm.onShowHistoryClicked.call(this, {params: param});
                }

                vm.onAssignPairingClick = function(param) {
                	vm.onAssignPairingClicked({params: param});
                }

                vm.onAssignEventClick = function(param) {
                	vm.onAssignEventClicked({params: param});
                }

                vm.onAssignTrainingClick = function(param) {
                	vm.onAssignTrainingClicked({params: param});
                }

                vm.onBlockDeleteClick = function(param) {
                      vm.onBlockDeleteClicked({blocks: param});
                }

                vm.onEditBlockClick = function(param){
                	vm.onEditBlockClicked.call(this, {params: param});
                }

                vm.onShowRegulationsClick = function(param){
                	vm.onShowRegulationsClicked.call(this, {params: param});
                }

                vm.onEmailCrewScheduleClick = function(param){
                	vm.onEmailCrewScheduleClicked.call(this, {params: param});
                }

                vm.onEditPairingClick = function(param){
                	vm.onEditPairingClicked({params: param});
                }

                vm.onShowPaxMsgDetClick = function(param){
                	 vm.onShowPaxMsgDetClicked.call(this, {params: param});
                }

                vm.saveOtherPaymentDetail = function(param){
                	 vm.saveOtherPaymentDetails({'param': param});
                }

                vm.saveFlyingHoursDetail = function(param){
                	 vm.saveFlyingHoursDetails({'param': param});
                }

                vm.deleteFlyingHoursDetail = function(param){
                	 vm.deleteFlyingHoursDetails({'param': param});
                }

                function setDefaultUpgradeData(){
                	//if upgrade data is available
                	if(!!vm.crewUpgradeData && vm.crewUpgradeData.length> 0){
                		vm.crewUpgradeData[0].isDefaultUpgrade = true;
                		 for(var i=1; i<vm.crewUpgradeData.length;i++){
                			 vm.crewUpgradeData[i].isDefaultUpgrade = false;
                		 }
                	}
                } ;

              vm.changeDate = function (flag) {
                if (flag === 'birthday' && !!vm.personalInfoDTO.dob) {
                  if (!isDateBeforeCurrentDate(vm.personalInfoDTO.dob)) {
                    vm.personalInfo.$valid = false;
                    vm.dobAfterToday = true;
                  } else {
                    vm.personalInfo.$valid = true;
                    vm.dobAfterToday = false;
                  }
                } else if (flag === 'passportIssue' && !!vm.employmentInfoDTO.passportDateOfIssue) {
                  if (!isDateBeforeCurrentDate(vm.employmentInfoDTO.passportDateOfIssue)) {
                    vm.employmentInfo.$valid = false;
                    vm.passportIssuedDateAfterToday = true;
                  } else {
                    vm.employmentInfo.$valid = true;
                    vm.passportIssuedDateAfterToday = false;
                  }
                }
              };
              function isDateBeforeCurrentDate(strDate) {
                if (moment(strDate, "DD/MM/YYYY")
                    .isAfter(new Date())) {
                  return false;
                }
                return true;

              };

              vm.onClickAddAcmiRange = function (popover) {
                popover.popoverFlag = true;
                $scope.isEditACMIData = true;
              }

              vm.clickEditSaveAcmiRange = function () {
                if (!vm.model.isAcmiDatesValid || vm.model.isDisableACMIInfo) {
                $scope.isEditACMIData = false;
                  return;
                }
                else {
                  vm.onACMIRangeEditSave();
                }
              }

              vm.validateDates = function(range) {
                if (moment(range.acmiEndDateStr, "DD/MM/YYYY").toDate() < moment(range.acmiStartDateStr, "DD/MM/YYYY").toDate()) {
                  range.dateError = true;  // Show error message
                  vm.model.isAcmiDatesValid = false;
                } else {
                  range.dateError = false; // Hide error message
                  vm.model.isAcmiDatesValid = true;
                }
              };

              vm.validateSecondaryBaseDateRange = function() {
                if (moment(vm.crewSecondaryBasePopOver.effectiveFromDate, "DD/MM/YYYY").toDate() > moment(vm.crewSecondaryBasePopOver.effectiveToDate , "DD/MM/YYYY").toDate()) {
                  vm.crewSecondaryBasePopOver.fromDateAfterToDate = true;
                } else {
                  vm.crewSecondaryBasePopOver.fromDateAfterToDate =  false;
                }
              };

              vm.deleteRange = function (range) {
                vm.onACMIRangeDelete({'rangeId':range.rangeId});
                $scope.isEditACMIData = true;
              };

              vm.onACMITypeSelected = function (range) {

                if (range.acmiType == null || typeof range.acmiType === 'undefined') {
                vm.model.isDisableACMIInfo = true;
                }
                else {
                  vm.model.isDisableACMIInfo = false;
                  range.rangeDesc = range.acmiType.acmiDescription;
                }
              }

              vm.onACMITypeSelectedAdd = function () {

                vm.addAcmiRangePopover.rangeDesc = vm.addAcmiRangePopover.acmiType.acmiDescription;

              }
            },
            bindings: {
                crewDetails: '<',
                crewExclusion: '<',
                airportExclusion: '<',
                airportInclusion: '<',
                crewTypes: '<',
                crewBatchList: '<',
                crewAttributeList: '<',
                alvGroups: '<',
                crewGroups: '<',
                offContracts: '<',
                baseList: '<',
                baseType: '<',
                nationalityList: '<',
                mgtPositions: '<',
                languageSkill: '<',
                languageList: '<',
                trainerTypes: '<',
                trainerTypesForTrainingStages: '<',
                defaultValidations: '<',
                fleetExperienceDetails: '<',
                crewBaseAssignments: '<',
                secondaryCrewBaseAssignments: '<',
                crewACMIAssignmentRanges: '<',
                assignedCrewBatches: '<',
                onSaveCrewBatchChanges: '&',
                searchCriteria: '<',
                effectedBaseList: '<',
                aircraftTypes: '<',
                paymentDetails: '<',
                crewPaymentRangeDetails : '=',
                crewOtherPaymentDetails : '=',
                crewUpgradeData: '<',
                crewTrainingStages: '<',
                airports: '<',
                allCrewList: '<',
                crewTypeWiseNameList: '<',
                countryNameWiseAirportList: '<',
                createNewProfile: '<',
                showCivilId: '<',
                imageUrl: '<',
                carrier: '<',
                enableRosterTab: '<',
                autoImportAllowedClients : '<',
                onDefaultValidationSave: '&',
                addDeleteLanguageSkill: '&',
                addEditFleetExperience: '&',
                addEditCrewBase: '&',
                addEditCrewSecondaryBase: '&',
                getEffectedBaseList: '&',
                addCrewACMIDateRange: '&',
                deleteCrewBaseController: '&',
                deleteCrewSecondaryBaseController: '&',
                addEditPositionDateRange: '&',
                deleteDateRangeController: '&',
                openCrewBaseHistoryController: '&',
                openCrewPreferenceHistoryController: '&',
                openCrewSecondaryBaseHistoryController: '&',
                addEditCrewUpgrade: '&',
                addEditTrainingStage: '&',
                updatePaymentInfo: '&',
                crewNavigation: '&',
                saveAddEditExclusion: '&',
                saveAddEditInclusion: '&',
                editSaveProfile: '&',
                onCrewTypeChange: '&',
                deleteCrewUpgrade:'&',
                crewOperTypes:'<',
                newCrewBasePopover:'=',
                newCrewSecondaryBasePopover:'=',
                lastCrewBaseOpenPopOver:'=',
                lastCrewSecondaryBaseOpenPopOver:'=',
                crewBasePopOver:'=',
                crewSecondaryBasePopOver:'=',
                newDateRangePopover:'=',
                lastDateRangeOpenPopOver:'=',
                dateRangePopOver:'=',
                addAcmiRangePopover:'=',
                weekDays: '<',
                calendar: '<',
                fromDate: '<',
                toDate: '<',
                onMonthNavigationClick: '&',

                onAssignPairingClicked: '&',
                onAssignEventClicked: '&',
                onAssignTrainingClicked: '&',
                addMemoClicked: '&',
                onDirectActionClicked: '&',
                onSendAlertClicked: '&',
                onSendSmsClicked: '&',
                onShowHistoryClicked: '&',
                onBlockDeleteClicked: '&',
                onEditBlockClicked: '&',
                onShowRegulationsClicked: '&',
                onEmailCrewScheduleClicked: '&',
                onEditPairingClicked: '&',
                onShowPaxMsgDetClicked: '&',
                saveOtherPaymentDetails: '&',
                saveFlyingHoursDetails : '&',
                deleteFlyingHoursDetails: '&',
                crewActualScheduleData: '<',
                alertsDetailsData: '<',
                memoDetailsData: '<',
                viewModeData: '<',
                crewPublishScheduleData: '<',
                crewDetailsData: '<',
                dobAfterToday : '=',
                passportIssuedDateAfterToday : '=',
                openCrewACMIOperationsHistoryController : '&',
                getCrewACMIEffectiveRanges : '&',
                onACMIRangeEditSave : '&',
                onACMIRangeDelete : '&',
                updateTrainingStageStatus: '&',
                crewAirportRecency: '<',
                crewLayoverAccommodationPreferences: '<',
                acmiTypes: '<',
                airportRecencyLastRefreshTime: '<',
                refreshAirportRecencyData: '&',
                addNewLayoverAccommodationPreference: '&',
                editLayoverAccommodationPreference: '&',
                deleteLayoverAccommodationPreference: '&',
                singleSignOn : '&',
                webAccessInfoDTO: '=',
                userRoles: '<',
                passwordRegexMisMatch: '<',
                designationList: '<'
            }
        });
})();
